
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leaderboards/[...slug]",
      function () {
        return require("private-next-pages/leaderboards/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leaderboards/[...slug]"])
      });
    }
  